/**
 * Responsibility: Implement index behavior for the engine layer.
 * Scope: Owns engine-layer concerns only; cross-layer orchestration is excluded.
 */
import { registerCheck } from '../supervisor-engine'
import { actorCheck } from './actor-check'
import { inventoryCheck } from './inventory-check'
import { atlasCheck } from './atlas-check'
import { combatCheck } from './combat-check'
import { questCheck } from './quest-check'
import { effectCheck } from './effect-check'
import { persistenceCheck } from './persistence-check'
import { objectCheck } from './object-check'
import { stateCheck } from './state-check'
import { worldSimCheck } from './world-sim-check'

let registered = false
export function registerDefaultSupervisorChecks() {
  if (registered) return
  registered = true
  registerCheck('actor.core', actorCheck)
  registerCheck('inventory.core', inventoryCheck)
  registerCheck('atlas.core', atlasCheck)
  registerCheck('combat.core', combatCheck)
  registerCheck('quest.core', questCheck)
  registerCheck('effect.core', effectCheck)
  registerCheck('persistence.core', persistenceCheck)
  registerCheck('object.core', objectCheck)
  registerCheck('state.core', stateCheck)
  registerCheck('worldsim.core', worldSimCheck)
}
